import React, { Component } from 'react'
import ReactDatePicker from 'react-datepicker'
import { Box, FormErrorMessage, FormControl } from '@chakra-ui/react'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'
import 'react-datepicker/dist/react-datepicker.css'
import './date-picker.css'
import { getKioskDocument } from 'src/utils/helpers'
import OutsideClickHandler from 'src/components/OutsideClickHandler/index'

class TimePicker extends Component {
  state = {
    isFocused: false,
    isHovered: false,
    isOpen: false,
  }

  toggleCalendarIcon = () => {
    const { isFocused, isHovered } = this.state
    if (isFocused || isHovered) {
      this.props.input.onChange(null)
    }
  }

  render() {
    const doc = getKioskDocument()
    const {
      meta,
      isClearable,
      showPopperArrow,
      name,
      placeholder,
      input,
      input: { value },
      ...props
    } = this.props

    return (
      <OutsideClickHandler
        onOutsideClick={() => {
          this.setState({ isOpen: false, isHovered: false, isFocused: false })
        }}
      >
        <FormControl isInvalid={meta && meta.touched && meta.error}>
          <Box
            pos='relative'
            onMouseOver={() => this.setState({ isHovered: true })}
            onMouseLeave={() => this.setState({ isHovered: false })}
          >
            <ReactDatePicker
              name={name}
              renderCalendarTo={doc.body}
              popperProps={{ strategy: 'fixed' }}
              wrapperClassName={meta && meta.touched && meta.error ? 'wrapper--has-error' : ''}
              placeholderText={placeholder}
              selected={value ? new Date(value) : null}
              isClearable={isClearable}
              showTimeSelect
              timeIntervals={10}
              showTimeSelectOnly
              dateFormat='h:mm aa'
              onChange={date => {
                if (date) {
                  input.onChange(date)
                } else {
                  input.onChange(null)
                }
                this.setState({ isFocused: false, isHovered: false, isOpen: false })
              }}
              open={this.state.isOpen}
              onInputClick={() => this.setState({ isOpen: true, isFocused: true })}
              onClickOutside={() => this.setState({ isOpen: false })}
              onCalendarOpen={() => this.setState({ isFocused: true, isOpen: true })}
              onBlur={() =>
                setTimeout(() => {
                  this.setState({ isFocused: false, isOpen: false })
                }, 400)
              }
              onKeyDown={e => {
                if (e.target.value.length === 10 && e.keyCode !== 8) {
                  e.preventDefault()
                }
              }}
              showPopperArrow={showPopperArrow}
              popperPlacement='bottom-end'
              {...props}
            />
            <Box cursor='pointer' onClick={this.toggleCalendarIcon}>
              {(value && this.state.isFocused) || (value && this.state.isHovered) ? (
                <Box pos='absolute' right={'20px'} top={'10px'} zIndex='2'>
                  <FontAwesomeIconComponent
                    icon={['far', 'xmark']}
                    size='xs'
                    type='input-icon-color'
                  />
                </Box>
              ) : (
                <Box pos='absolute' right={'20px'} top={'10px'} zIndex='2'>
                  <FontAwesomeIconComponent
                    icon={['far', 'clock']}
                    size='xs'
                    type='input-icon-color'
                  />
                </Box>
              )}
            </Box>
          </Box>
          <FormErrorMessage>{meta && meta.error}</FormErrorMessage>
        </FormControl>
      </OutsideClickHandler>
    )
  }
}

export default TimePicker
